import React, { useContext } from 'react'
import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock'
import { getNumTitles } from '@App/helpers/pagination/get-num-titles'
import WorkItemList from '@Components/WorkItemList'
import PaginationComponent from '@Components/Tables/Pagination'
import { StoresContext } from '@App/contexts'
import { PaginationBody } from '@Entities/pagination'
import { observer } from 'mobx-react'
import { Works } from '@Entities/work/works'

interface MatchSearchResultsProps {
    resultsData: Works
    selectWork: (songCode: string, title: string) => void
    handleSearch: (pagination?: PaginationBody) => void
}

const MatchSearchResults = (props: MatchSearchResultsProps) => {
    const { catalogSearchStore } = useContext(StoresContext)
    const { resultsData, selectWork, handleSearch } = props

    const currentPagination = catalogSearchStore.worksRightsHolderPaginationInfo
    const currentPage = currentPagination ? currentPagination.currentPage : 1

    return (
        <div className="search-results">
            {resultsData.count === 0 ? (
                <p className="small bold no-results">No results found.</p>
            ) : (
                <PaginationResultsBlock
                    totalResults={resultsData.count}
                    workNumTitles={getNumTitles(resultsData.count, currentPage, 5)}
                />
            )}
            <WorkItemList workItems={resultsData.works} selectWork={selectWork} />
            {resultsData.count > 0 && (
                <PaginationComponent limit={5} paginationPages={currentPagination} onChange={handleSearch} />
            )}
        </div>
    )
}

export default observer(MatchSearchResults)
